/**
 * Sistema de notificação visual na aba do navegador
 * - Pisca o título da página
 * - Alterna o favicon
 * - Para quando o usuário retorna à aba
 */
var TabAlertNotifier = /** @class */ (function () {
    function TabAlertNotifier() {
        var _this = this;
        this.originalTitle = '';
        this.originalFavicon = '';
        this.isBlinking = false;
        this.blinkInterval = null;
        this.alertCount = 0;
        this.originalTitle = document.title;
        this.originalFavicon = this.getFaviconUrl();
        // Para de piscar quando o usuário volta para a aba
        document.addEventListener('visibilitychange', function () {
            if (!document.hidden && _this.isBlinking) {
                _this.stopBlinking();
            }
        });
        // Para de piscar quando a janela recebe foco
        window.addEventListener('focus', function () {
            if (_this.isBlinking) {
                _this.stopBlinking();
            }
        });
    }
    TabAlertNotifier.prototype.getFaviconUrl = function () {
        var link = document.querySelector("link[rel*='icon']");
        return (link === null || link === void 0 ? void 0 : link.href) || '/favicon.ico';
    };
    TabAlertNotifier.prototype.setFavicon = function (url) {
        var link = document.querySelector("link[rel*='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }
        link.href = url;
    };
    /**
     * Cria um favicon vermelho para alertas
     */
    TabAlertNotifier.prototype.createAlertFavicon = function () {
        var canvas = document.createElement('canvas');
        canvas.width = 32;
        canvas.height = 32;
        var ctx = canvas.getContext('2d');
        if (!ctx)
            return this.originalFavicon;
        // Círculo vermelho
        ctx.fillStyle = '#FF0000';
        ctx.beginPath();
        ctx.arc(16, 16, 14, 0, 2 * Math.PI);
        ctx.fill();
        // Borda branca
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = 2;
        ctx.stroke();
        // Número de alertas (se houver)
        if (this.alertCount > 0) {
            ctx.fillStyle = '#FFFFFF';
            ctx.font = 'bold 16px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var text = this.alertCount > 9 ? '9+' : this.alertCount.toString();
            ctx.fillText(text, 16, 16);
        }
        else {
            // Símbolo de exclamação
            ctx.fillStyle = '#FFFFFF';
            ctx.font = 'bold 20px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText('!', 16, 16);
        }
        return canvas.toDataURL();
    };
    /**
     * Inicia a animação de alerta
     */
    TabAlertNotifier.prototype.startBlinking = function (alertMessage) {
        var _this = this;
        if (alertMessage === void 0) { alertMessage = '🚨 NOVO ALERTA!'; }
        if (this.isBlinking) {
            // Se já está piscando, apenas incrementa o contador
            this.alertCount++;
            return;
        }
        this.isBlinking = true;
        this.alertCount = 1;
        var toggle = false;
        var alertFavicon = this.createAlertFavicon();
        this.blinkInterval = setInterval(function () {
            if (toggle) {
                document.title = _this.originalTitle;
                _this.setFavicon(_this.originalFavicon);
            }
            else {
                document.title = "".concat(alertMessage, " (").concat(_this.alertCount, ")");
                _this.setFavicon(alertFavicon);
            }
            toggle = !toggle;
        }, 1000); // Alterna a cada 1 segundo
        // console.log('🔔 Notificação visual na aba iniciada');
    };
    /**
     * Para a animação e restaura título/favicon originais
     */
    TabAlertNotifier.prototype.stopBlinking = function () {
        if (this.blinkInterval) {
            clearInterval(this.blinkInterval);
            this.blinkInterval = null;
        }
        this.isBlinking = false;
        this.alertCount = 0;
        document.title = this.originalTitle;
        this.setFavicon(this.originalFavicon);
        // console.log('✅ Notificação visual na aba removida');
    };
    /**
     * Verifica se está piscando
     */
    TabAlertNotifier.prototype.isCurrentlyBlinking = function () {
        return this.isBlinking;
    };
    /**
     * Atualiza o título original (útil para mudanças de rota)
     */
    TabAlertNotifier.prototype.updateOriginalTitle = function (newTitle) {
        this.originalTitle = newTitle;
        if (!this.isBlinking) {
            document.title = newTitle;
        }
    };
    return TabAlertNotifier;
}());
// ✅ Instância singleton
export var tabAlertNotifier = new TabAlertNotifier();
// ✅ Funções auxiliares de fácil uso
export var startTabAlert = function (message) {
    tabAlertNotifier.startBlinking(message);
};
export var stopTabAlert = function () {
    tabAlertNotifier.stopBlinking();
};
export var isTabAlerting = function () {
    tabAlertNotifier.isCurrentlyBlinking();
};
